import React, { useEffect } from "react";
import "../../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayCommaFormatter,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useSelector } from "react-redux";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
// let tableData = [
//   { gstin: "12456789", tigst: 1000, tsgst: 1000, tcgst: 1000, inum: 123 },
// ];
const Table = (props) => {
  const { supplierWiseTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const columns = [
    {
      dataField: "RECIPIENT_GSTIN",
      text: "Recipient GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RECIPIENT_GSTIN"),
    },
    {
      dataField: "CTIN",
      text: "Supplier GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN"),
    },
    {
      dataField: "PAN",
      text: "PAN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "PAN"),
    },
    {
      dataField: "CNAME",
      text: "Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CNAME"),
    },

    {
      dataField: "TOTAL_GST_PR",
      text: "Total GST as per PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TOTAL_GST_PR"),
    },
    {
      dataField: "TOTAL_GST_SALE",
      text: "Total GST as per 2A/2B",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TOTAL_GST_SALE"),
    },
    {
      dataField: "DIFFERENCE",
      text: "Difference",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
            formatter: (cell, row) => displayCommaFormatter(row, "DIFFERENCE"),

     
    },
    {
      dataField: "DIFFERENCE_PCT",
      text: "% Difference",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      // formatter: (cell, row) => displayNullFormatter(row, "DIFFERENCE_PCT"),
       formatter: (cell, row) => {
        const value = row["DIFFERENCE_PCT"];
        if (value === null || value === undefined || value === "") {
          return "-";
        }
        const numericValue = parseFloat(value);
        return isNaN(numericValue) ? "-" : numericValue.toFixed(1);
      },
    },
    {
      dataField: "MATCHED_AS_PER_PR",
      text: "Matched as per PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "9%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "MATCHED_AS_PER_PR"),
    },
  ];
  useEffect(() => {
    console.log("supplierWiseTableData::", supplierWiseTableData);
  }, [supplierWiseTableData]);
  return (
    <>
      {supplierWiseTableData?.length > 0 ? (
        <>
          {" "}
          <div
            style={{ marginTop: "0.5em", width: "100%", overflowX: "scroll" }}
          >
            <div
              className="light-border-gstr2a2bnew-table"
              style={{ height: "25em", width: "180%", overflowY: "scroll" }}
            >
              <BootstrapTable
                keyField="uniqueKey"
                data={supplierWiseTableData}
                columns={columns}
                rowStyle={rowStyle2}
              />
            </div>
          </div>
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
